module.exports = __webpack_public_path__ + "img/raycaster.e3d750e8.png";